(() => {
  if (window.PgSetSwitch) {
    window.PgSetSwitch.initAll();
    return;
  }

  const init = (root) => {
    if (root.dataset.pgSetSwitchReady === 'true') return;

    const sectionId = root.dataset.sectionId;
    const form = document.getElementById(root.dataset.productFormId);
    const variantInput = form?.querySelector('input[name="id"]');
    const submitLabel = form?.querySelector('.product-form__submit > span:first-child');
    const singlePrice = document.getElementById(`price-${sectionId}`);
    const setPrice = document.getElementById(`pg-set-price-${sectionId}`);
    const singleBasePrice = document.getElementById(`pg-single-base-price-${sectionId}`);
    const setBasePrice = document.getElementById(`pg-set-base-price-${sectionId}`);
    const productInfo = root.closest('product-info');
    const quantityInput = productInfo?.querySelector('quantity-input[data-url]');
    const liveRegion = root.querySelector('[data-pg-set-switch-live]');
    const choices = Array.from(root.querySelectorAll('input[name="pg-set-choice"]'));

    if (!form || !variantInput || !submitLabel || !singlePrice || !setPrice || choices.length !== 2) return;

    root.dataset.pgSetSwitchReady = 'true';
    const originalSubmitText = submitLabel.textContent.trim();

    const select = (choice, announce = true) => {
      const useSet = choice === 'set';
      const selectedInput = choices.find((input) => input.value === choice);
      if (!selectedInput) return;

      selectedInput.checked = true;
      variantInput.value = useSet ? root.dataset.setVariantId : root.dataset.singleVariantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      singlePrice.hidden = useSet;
      setPrice.hidden = !useSet;
      if (singleBasePrice) singleBasePrice.hidden = useSet;
      if (setBasePrice) setBasePrice.hidden = !useSet;
      submitLabel.textContent = useSet ? 'Set in den Warenkorb' : originalSubmitText;

      const productUrl = useSet ? root.dataset.setUrl : root.dataset.singleUrl;
      if (productInfo && productUrl) productInfo.dataset.url = productUrl;
      if (quantityInput && productUrl) quantityInput.dataset.url = productUrl;

      root.dataset.pgSetSelection = choice;
      if (announce && liveRegion) {
        liveRegion.textContent = '';
        window.requestAnimationFrame(() => {
          liveRegion.textContent = useSet ? root.dataset.setAnnouncement : root.dataset.singleAnnouncement;
        });
      }
    };

    root.addEventListener('change', (event) => {
      if (event.target.matches('input[name="pg-set-choice"]') && event.target.checked) {
        select(event.target.value);
      }
    });

    let initialChoice = 'single';
    try {
      if (new URLSearchParams(window.location.search).get('kaufoption') === 'set') initialChoice = 'set';
    } catch (error) {
      initialChoice = 'single';
    }
    select(initialChoice, initialChoice === 'set');
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-pg-set-switch]').forEach(init);
  };

  window.PgSetSwitch = { initAll };
  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
